'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var DropDownMenu = _react2['default'].createClass({
    displayName: 'DropDownMenu',


    propTypes: {
        dropDownMenuLinkData: _react2['default'].PropTypes.array.isRequired,
        className: _react2['default'].PropTypes.string,
        style: _react2['default'].PropTypes.object,
        id: _react2['default'].PropTypes.string
    },

    render: function render() {
        var dropDownMenuLinks = this.props.dropDownMenuLinkData.map(function (dropDownMenuLink, i, linkArray) {
            if (!dropDownMenuLink.hasOwnProperty('options') || dropDownMenuLink.hasOwnProperty('options') && !dropDownMenuLink.options.mobileMenuOnly) {
                var target = dropDownMenuLink.options ? dropDownMenuLink.options.target : null;
                return _react2['default'].createElement(
                    'a',
                    { key: i, className: 'm-arrow-box--link hc-cerulean c-ashen' + (i == linkArray.length - 1 ? ' last' : ''), href: dropDownMenuLink.url, target: target },
                    dropDownMenuLink.text
                );
            }
        }.bind(this));
        return _react2['default'].createElement(
            'div',
            {
                style: this.props.style,
                className: 'm-arrow-box ' + (this.props.className || ''), id: this.props.id || 'google-dropdown-menu' },
            dropDownMenuLinks
        );
    }
});
module.exports = DropDownMenu;


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/components/drop-down-menu.jsx
 ** module id = 708
 ** module chunks = 0
 **/